import { Card, Grid2 } from "@mui/material";
import TreeNode from "./TreeNode";
import useTrees from "../../../../../Hooks/useTrees";
import { repositoryPickerId } from "../../../../UI/Specialized/RepositoryPicker";
import { getGreylistId } from "../../../../UI/Specialized/Actions/getGreylist";
import { greylistTreeReady } from "./Pickers/GreylstPicker";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../Hooks/useWorker";

const Body = () => {
  const { UI } = useUIBp();
  const { done, error } = useWorker(getGreylistId);
  const { done: treeReady } = useWorker(greylistTreeReady);
  const repoId = UI[repositoryPickerId] ?? "";
  const trees = useTrees();
  const tree = trees["greylist-" + repoId] ?? { nodes: [] };

  const rootNode = tree.nodes.length ? (
    <TreeNode {...{ tree: tree.nodes, idx: 0, level: 0 }} />
  ) : null;

  return (
    <Grid2 container size={12}>
      {done && !error && treeReady ? (
        <Card
          {...{
            wrap: "nowrap",
            sx: {
              borderColor: "LightGray",
              borderStyle: "solid",
              borderWidth: "1px",
              boxShadow: "none",
              padding: "0.5rem",
              maxHeight: 450,
              overflowY: "auto",
              overflowX: "hidden",
              width: "100%",
            },
          }}
        >
          <Grid2 container>{rootNode}</Grid2>
        </Card>
      ) : null}
    </Grid2>
  );
};

export default Body;
